export const ROUTER_PATHS = {
	root: { path: '/', getLink: () => '/' },
	login: { path: '/login', getLink: () => '/login' },
	plantMaintenance: {
		path: '/plant-maintenance',
		getLink: () => '/plant-maintenance',
	},
	plantMaintenanceDetail: {
		path: '/plant-maintenance/:id',
		getLink: (id: string) => `/plant-maintenance/${id}`,
	},
	plantNotifications: {
		path: '/plant-notifications',
		getLink: () => '/plant-notifications',
	},
	campaign: { path: '/campaign', getLink: () => '/campaign' },
	logistics: { path: '/logistics', getLink: () => '/logistics' },
	userProfile: {
		path: '/profile/:userId',
		getLink: (userId: string) => `/profile/${userId}`,
	},
	reports: { path: '/reports', getLink: () => '/reports' },
	settings: { path: '/settings', getLink: () => '/settings' },
} as const;
